<div class="main_body">
  <app-page-header
    title="ユーザー" i18n-title="@@home.homeUserList.title.main"
    subtitle="セクションに登録されているユーザー一覧を表示します。" i18n-subtitle="@@home.homeUserList.subtitle.main"
    icon="user">
  </app-page-header>

  <div class="contents">

    <div class="contents_section_group">
      <section class="contents__section">

        <div class="table-toolbar">
          <!-- Left: Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            role="search"
            (click)="!searchExpanded() && expandSearch()"
          >
            @if (!searchExpanded()) {
              <mat-icon class="search-pill__icon">search</mat-icon>
              <span
                class="search-pill__placeholder"
                i18n="@@home.homeUserList.search.placeholder"
              >検索</span>
            } @else {
              <mat-icon class="search-pill__icon search-pill__icon--active">search</mat-icon>
              <input
                #searchInput
                type="text"
                class="search-pill__input"
                [value]="filterText"
                (input)="applyFilter($event)"
                (blur)="onSearchBlur()"
                placeholder="コード・氏名・生年月日で検索"
                i18n-placeholder="@@home.homeUserList.search.inputPlaceholder"
                aria-label="コード・氏名・生年月日で検索"
                i18n-aria-label="@@home.homeUserList.search.ariaLabel"
              />
              @if (filterText.trim()) {
                <button
                  mat-icon-button
                  class="search-pill__clear"
                  (mousedown)="$event.preventDefault()"
                  (click)="clearSearch()"
                  aria-label="検索をクリア"
                  i18n-aria-label="@@home.homeUserList.search.clearAriaLabel"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            }
          </div>

          <!-- Right: Actions -->
          <div class="table-toolbar__actions">
            <div class="filter-chips">
              <mat-chip-listbox class="inactive-filter-chip-list" aria-label="フィルター">
                <mat-chip-option
                  class="inactive-filter-chip"
                  [selected]="inactiveOnly"
                  (selectionChange)="onInactiveFilterChange($event)"
                  color="primary"
                  matTooltip="3ヶ月以上更新がない場合"
                  i18n-matTooltip="@@home.homeUserList.tooltip.inactiveExplanation"
                >
                  <mat-icon matChipAvatar>schedule</mat-icon>
                  <span i18n="@@home.homeUserList.chip.inactiveOnly">長期更新なし</span>
                </mat-chip-option>
              </mat-chip-listbox>
            </div>

            @if ((vm$ | async); as vmToolbar) {
              <!-- Column Show/Hide -->
              <button
                mat-icon-button
                class="table-toolbar__btn"
                [matMenuTriggerFor]="columnMenu"
                matTooltip="表示項目の切替"
                aria-label="表示項目の切替"
                i18n-matTooltip="@@home.homeUserList.tooltip.columns"
                i18n-aria-label="@@home.homeUserList.ariaLabel.columns"
              >
                <mat-icon>filter_list</mat-icon>
              </button>
              <mat-menu #columnMenu="matMenu" class="column-menu">
                <div class="column-menu__content" (click)="$event.stopPropagation()">
                  <span class="column-menu__label" i18n="@@home.homeUserList.label.showHideColumn">カラム表示/非表示</span>
                  <mat-divider></mat-divider>
                  @for (cd of vmToolbar.columnDefinitions; track cd.def) {
                    @if (!cd.locked && cd.label) {
                      <mat-checkbox
                        [checked]="cd.visible"
                        (change)="toggleColumnVisibility(cd.def)"
                        color="primary"
                      >
                        {{ cd.label }}
                      </mat-checkbox>
                    }
                  }
                </div>
              </mat-menu>

              <!-- Add User -->
              @if (vmToolbar.userManagementRole) {
                <button
                  mat-icon-button
                  class="table-toolbar__btn"
                  (click)="openCreateUser()"
                  matTooltip="ユーザー追加"
                  aria-label="ユーザー追加"
                  i18n-matTooltip="@@home.homeUserList.tooltip.addUser"
                  i18n-aria-label="@@home.homeUserList.ariaLabel.addUser"
                >
                  <mat-icon>person_add</mat-icon>
                </button>
              }

              <!-- Refresh -->
              <button
                mat-icon-button
                class="table-toolbar__btn"
                (click)="refreshData()"
                matTooltip="更新"
                aria-label="更新"
                i18n-matTooltip="@@home.homeUserList.tooltip.refresh"
                i18n-aria-label="@@home.homeUserList.ariaLabel.refresh"
              >
                <mat-icon>refresh</mat-icon>
              </button>

              <!-- View Toggle -->
              <div class="view-toggle" role="group" aria-label="表示切替">
                <button
                  mat-icon-button
                  [class.view-toggle--active]="vmToolbar.viewMode === 'card'"
                  (click)="toggleViewMode('card')"
                  matTooltip="カード表示"
                  aria-label="カード表示"
                  i18n-matTooltip="@@home.homeUserList.tooltip.cardView"
                  i18n-aria-label="@@home.homeUserList.ariaLabel.cardView"
                >
                  <mat-icon>view_module</mat-icon>
                </button>
                <button
                  mat-icon-button
                  [class.view-toggle--active]="vmToolbar.viewMode === 'table'"
                  (click)="toggleViewMode('table')"
                  matTooltip="テーブル表示"
                  aria-label="テーブル表示"
                  i18n-matTooltip="@@home.homeUserList.tooltip.tableView"
                  i18n-aria-label="@@home.homeUserList.ariaLabel.tableView"
                >
                  <mat-icon>view_list</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
        @if ((vm$ | async); as vmState) {
          <!-- Card View -->
          @if (vmState.viewMode === 'card') {
            <div class="user-card-grid" [class.is-refreshing]="vmState.status !== 'success' || vmState.refreshing">
              @for (row of vmState.pagedRows; track row.user.userId) {
                <div
                  class="user-card"
                  [class.card-inactive]="isInactive(row)"
                  (click)="navigateToSubpage(row)"
                  (keydown.enter)="navigateToSubpage(row)"
                  tabindex="0"
                  role="button"
                >
                  <div class="user-card__header">
                    <div class="user-card__identity">
                      <span class="user-card__code">{{ row.user.code }}</span>
                      <span class="user-card__name">{{ row.user.lastName }} {{ row.user.firstName }}</span>
                      @if (isInactive(row)) {
                        <span
                          class="inactive-pill"
                          matTooltip="3ヶ月以上更新がない場合"
                          i18n-matTooltip="@@home.homeUserList.tooltip.inactiveExplanation"
                          i18n="@@home.homeUserList.status.inactiveBadge"
                        >長期更新なし</span>
                      }
                    </div>
                    <div class="user-card__meta">
                      @if (isColumnVisible(vmState, 'sex')) {
                        @if (row.user.sex === 'male') {
                          <span class="badge badge--info">{{ row.user.sex | sexLang : sexLanguage }}</span>
                        }
                        @if (row.user.sex === 'female') {
                          <span class="badge badge--danger">{{ row.user.sex | sexLang : sexLanguage }}</span>
                        }
                      }
                      @if (isColumnVisible(vmState, 'birthDate') && row.user.birthDate) {
                        <span class="user-card__birthdate">{{ row.user.birthDate | formatDate : 'YYYY/MM/DD' }}</span>
                      }
                    </div>
                  </div>

                  @if (getCardDynamicAttrs(vmState).length > 0) {
                    <div class="user-card__attrs">
                      @for (attr of getCardDynamicAttrs(vmState); track attr.name) {
                        <div class="user-card__attr-row">
                          <span class="user-card__attr-label">{{ common.getDispName(attr) }}</span>
                          @if (attr.type === 'Bool') {
                            @if (getUserDataItemNewestValue(row, attr.name) === 'true') {
                              <mat-icon
                                class="user-card__attr-icon"
                                [color]="!getUserDataItemsNewestAndSecondAreEqual(row, attr.name) ? 'warn' : undefined"
                              >check_circle</mat-icon>
                            } @else {
                              <span class="user-card__attr-value">-</span>
                            }
                          } @else {
                            <span class="user-card__attr-value">{{ getUserDataItemValueCompare(row, attr.name) }}</span>
                          }
                        </div>
                      }
                    </div>
                  }

                  <div class="user-card__footer">
                    @if (isColumnVisible(vmState, 'lastUpdatedProtocol')) {
                      @let protocol = row.userStatistics?.data?.lastUpdatedProtocol;
                      <div class="user-card__attr-row">
                        <span class="user-card__attr-label" i18n="@@home.homeUserList.card.label.lastUpdatedProtocol">最終更新プロトコル</span>
                        <span class="user-card__attr-value user-card__protocol">
                          <span
                            class="protocol-inline"
                            [matTooltip]="getProtocolTooltip(protocol)"
                            [matTooltipDisabled]="!getProtocolSecondaryDisplay(protocol)"
                          >
                            <span class="protocol-inline__primary">{{ getProtocolPrimaryDisplay(protocol) }}</span>
                            @if (getProtocolSecondaryDisplay(protocol); as secondaryLabel) {
                              <span class="protocol-inline__secondary">{{ secondaryLabel }}</span>
                            }
                          </span>
                        </span>
                      </div>
                    }
                    @if (isColumnVisible(vmState, 'lastUpdated')) {
                      <div class="user-card__attr-row">
                        <span class="user-card__attr-label" i18n="@@home.homeUserList.card.label.lastUpdated">最終更新日</span>
                        <span class="user-card__attr-value user-card__date">
                          {{ getDate(row.userStatistics?.data?.lastUpdatedProtocolCreatedAt) ?? '-' }}
                        </span>
                      </div>
                    }
                    @if (hasSummaryAccess()) {
                      <div class="user-card__summary">
                        <button
                          mat-stroked-button
                          type="button"
                          class="user-card__summary-button"
                          (click)="navigateToSummary(row, $event)"
                          matTooltip="サマリー"
                          aria-label="サマリー"
                          i18n-matTooltip="@@home.homeUserList.tooltip.summary"
                          i18n-aria-label="@@home.homeUserList.ariaLabel.summary"
                        >
                          <mat-icon class="user-card__summary-icon" aria-hidden="true">summarize</mat-icon>
                          <span i18n="@@home.homeUserList.button.summary">サマリー</span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

          <!-- Table View -->
          @if (vmState.viewMode === 'table') {
            <div
              class="user-list-container mat-elevation-z0"
              [class.is-refreshing]="vmState.status !== 'success' || vmState.refreshing"
              #scrollContainer
              (scroll)="onTableScroll()"
            >
              <table
                mat-table
                class="user_record_table"
                [dataSource]="vmState.pagedRows"
                matSort
                matSortDisableClear
                [matSortActive]="vmState.sortActive"
                [matSortDirection]="vmState.sortDirection"
                (matSortChange)="onSortChange($event)"
              >
                <!-- 登録レコード Column -->
                <ng-container matColumnDef="userRecord">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@home.homeUserList.column.userRecord">
                    ユーザー
                  </th>
                  <td mat-cell *matCellDef="let res" class="user-record-cell">
                    <span class="user-record-text">
                      {{ res.user.code }} {{ res.user.lastName }} {{ res.user.firstName }}
                    </span>
                    @if (isInactive(res)) {
                      <span
                        class="inactive-inline-label"
                        matTooltip="3ヶ月以上更新がない場合"
                        i18n-matTooltip="@@home.homeUserList.tooltip.inactiveExplanation"
                        i18n="@@home.homeUserList.status.inactiveBadge"
                      >長期更新なし</span>
                    }
                  </td>
                </ng-container>

                <!-- 性別 Column -->
                <ng-container matColumnDef="sex">
                  <th mat-header-cell *matHeaderCellDef i18n="@@home.homeUserList.column.sex">性別</th>
                  <td mat-cell *matCellDef="let res" class="min-width-80">
                    @if (res.user.sex === 'male') {
                      <span class="badge badge--info">
                        {{ res.user.sex | sexLang : sexLanguage }}
                      </span>
                    }
                    @if (res.user.sex === 'female') {
                      <span class="badge badge--danger">
                        {{ res.user.sex | sexLang : sexLanguage }}
                      </span>
                    }
                  </td>
                </ng-container>

                <!-- 生年月日 Column -->
                <ng-container matColumnDef="birthDate">
                  <th mat-header-cell *matHeaderCellDef i18n="@@home.homeUserList.column.birthDate">生年月日</th>
                  <td mat-cell *matCellDef="let res">
                    {{ res.user.birthDate | formatDate : 'YYYY/MM/DD' }}
                  </td>
                </ng-container>

                <!-- 最終更新プロトコル Column -->
                <ng-container matColumnDef="lastUpdatedProtocol">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@home.homeUserList.column.lastUpdatedProtocol">
                    最終更新プロトコル
                  </th>
                  <td mat-cell *matCellDef="let res" class="user-table-protocol-cell">
                    @let protocol = res.userStatistics?.data?.lastUpdatedProtocol;
                    <span
                      class="protocol-inline"
                      [matTooltip]="getProtocolTooltip(protocol)"
                      [matTooltipDisabled]="!getProtocolSecondaryDisplay(protocol)"
                    >
                      <span class="protocol-inline__primary">{{ getProtocolPrimaryDisplay(protocol) }}</span>
                      @if (getProtocolSecondaryDisplay(protocol); as secondaryLabel) {
                        <span class="protocol-inline__secondary">{{ secondaryLabel }}</span>
                      }
                    </span>
                  </td>
                </ng-container>

                <!-- 最終更新日 Column -->
                <ng-container matColumnDef="lastUpdated">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@home.homeUserList.column.lastUpdated">
                    最終更新日
                  </th>
                  <td mat-cell *matCellDef="let res">
                    {{
                      getDate(
                        res.userStatistics?.data?.lastUpdatedProtocolCreatedAt
                      )
                    }}
                  </td>
                </ng-container>

                @for (userDataGroup of vmState.userDataAttributes; track userDataGroup; let i = $index) {
                  @for (attr of userDataGroup.dataItems; track attr; let j = $index) {
                    @if (attr.enabled && attr.showOnSummary) {
                      <ng-container [matColumnDef]="'column' + i + j">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ common.getDispName(attr) }}
                        </th>
                        <td mat-cell *matCellDef="let res" class="dynamic-column-cell">
                          @if (attr.type=='Bool') {
                            @if (getUserDataItemNewestValue(res, attr.name)=='true') {
                              <mat-icon
                                [color]="!getUserDataItemsNewestAndSecondAreEqual(res, attr.name) ? 'warn' : undefined"
                              >check_circle</mat-icon>
                            }
                          } @else {
                            <span
                              class="dynamic-column-text"
                              [matTooltip]="getUserDataItemValueCompare(res, attr.name)"
                              matTooltipShowDelay="300"
                            >
                              {{ getUserDataItemValueCompare(res, attr.name) }}
                            </span>
                          }
                        </td>
                      </ng-container>
                    }
                  }
                }

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
                  <td mat-cell *matCellDef="let res" class="actions-cell">
                    @if (hasSummaryAccess()) {
                      <button
                        mat-icon-button
                        class="summary-action-button"
                        (click)="navigateToSummary(res, $event)"
                        matTooltip="サマリー"
                        aria-label="サマリー"
                        i18n-matTooltip="@@home.homeUserList.tooltip.summary"
                        i18n-aria-label="@@home.homeUserList.ariaLabel.summary"
                      >
                        <mat-icon class="summary-action-icon" aria-hidden="true">summarize</mat-icon>
                        <span class="summary-action-label" i18n="@@home.homeUserList.button.summaryAction">サマリー</span>
                      </button>
                    }
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="vmState.displayedColumns; sticky: true"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: vmState.displayedColumns"
                  (click)="navigateToSubpage(row)"
                  [class.row-inactive]="isInactive(row)"
                ></tr>
              </table>
            </div>
          }

          <mat-paginator
            class="user-list-paginator"
            [class.is-refreshing]="vmState.status !== 'success' || vmState.refreshing"
            [length]="vmState.filteredRows.length"
            [pageIndex]="vmState.pageIndex"
            [pageSize]="vmState.pageSize"
            [pageSizeOptions]="[5, 10, 25, 100]"
            (page)="onPaginatorChange($event)"
          >
          </mat-paginator>
        }

      </section>

    </div>
    <!--/contents_section_group-->
  </div>
  <!-- /contents -->
